import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RegisterPracticeComponent } from './register-practice.component';
import { SharedModule } from '../../../../shared/shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

/**
 * Standalone module for RegisterPracticeComponent.
 * Shared by both HealthRoutesModule (public registration page)
 * and PracticesModule (enterprise "Add New Practice" modal).
 *
 * Note: RecaptchaModule, NgxMaskModule are already re-exported via SharedModule -> RegistrationModule.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    NgSelectModule,
    MatPasswordStrengthModule,
    MatSlideToggleModule,
  ],
  declarations: [
    RegisterPracticeComponent,
  ],
  exports: [
    RegisterPracticeComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RegisterPracticeModule { }
